// External
import client from "lib/apolloClient/client";

// Internal
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";

// Relative
import { migrateTermAssociatedDataMutation } from "./ViewAndMigrateTermAssociatedDataMutations";

export const migrateTermData = ({ input }) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: migrateTermAssociatedDataMutation,
        variables: {
          input,
        },
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            {
              key: "label",
              value: "toastMsgs:saved_configuration",
              isPlainText: false,
            },
          ],
        })
      );
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};
